import { useState } from "react";
import { userProfileIcon } from "../../icons/assets";

/**
 * Circular avatar with initials fallback when image fails / missing.
 */
const InviteAvatar = ({
  src,
  name = "",
  size = 40,
  className = "",
  alt,
}) => {
  const [failed, setFailed] = useState(false);
  const initials = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() || "")
    .join("");

  const showImage = Boolean(src) && !failed;

  return (
    <span
      className={`invite-avatar ${className}`.trim()}
      style={{ width: size, height: size }}
      aria-hidden={alt ? undefined : true}
    >
      {showImage ? (
        <img
          src={src}
          alt={alt || ""}
          width={size}
          height={size}
          onError={() => setFailed(true)}
        />
      ) : initials ? (
        <span className="invite-avatar__initials">{initials}</span>
      ) : (
        <img src={userProfileIcon} alt="" width={size} height={size} />
      )}
    </span>
  );
};

export default InviteAvatar;
